import { defineComponent as a, openBlock as n, createBlock as r, unref as l, mergeProps as m, withCtx as p, createElementVNode as i } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ a({
  name: "IconHomeFilled",
  __name: "IconHomeFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (s, e) => (n(), r(l(c), m(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        i("path", { d: "m12.768 2.83 8.692 6.761a.75.75 0 1 1-.92 1.184l-.79-.614v10.022a1.25 1.25 0 0 1-1.25 1.25h-4a1.25 1.25 0 0 1-1.25-1.25v-3.5a1.25 1.25 0 1 0-2.5 0v3.5a1.25 1.25 0 0 1-1.25 1.25h-4a1.25 1.25 0 0 1-1.25-1.25V10.161l-.79.614a.75.75 0 1 1-.92-1.184l8.693-6.761a1.25 1.25 0 0 1 1.534 0" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
